<template>
  <v-container>
    <h1 class="headline">Parents</h1>
    <router-view></router-view>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      menu: false,
      message: false,
      hints: true,
      modal: false,
      courses: [],
      allCourses: [
        {
          id: 0,
          title: "Beit Bialik",
          time: "4:00 PM - 6:00 PM",
          dates: ["2018-04-16", "2018-04-17"],
          type: "Beit Bialik",
          desc: "Test desc."
        },
        {
          id: 1,
          title: "Tennis",
          time: "4:00 PM - 5:00 PM",
          dates: ["2018-04-17"],
          type: "After 4",
          day: "monday"
        },
        {
          id: 2,
          title: "Voleyball",
          time: "4:00 PM - 5:00 PM",
          dates: ["2018-04-17"],
          type: "Beit Bialik"
        },
        {
          id: 3,
          title: "Dance",
          time: "4:00 PM - 5:00 PM",
          dates: ["2018-04-16"],
          type: "After 4",
          day: "tuesday"
        },
        {
          id: 3,
          title: "Dance",
          time: "4:00 PM - 5:00 PM",
          dates: ["2018-04-16"],
          type: "After 4",
          day: "wednesday"
        },
        {
          id: 3,
          title: "Dance",
          time: "4:00 PM - 5:00 PM",
          dates: ["2018-04-16"],
          type: "After 4",
          day: "thursday"
        },
        {
          id: 3,
          title: "Dance",
          time: "4:00 PM - 5:00 PM",
          dates: ["2018-04-16"],
          type: "After 4",
          day: "thursday"
        },
        {
          id: 3,
          title: "Dance",
          time: "4:00 PM - 5:00 PM",
          dates: ["2018-04-16"],
          type: "After 4",
          day: "thursday"
        },
        {
          id: 3,
          title: "Dance",
          time: "4:00 PM - 5:00 PM",
          dates: ["2018-04-16"],
          type: "After 4",
          day: "thursday"
        },
        {
          id: 3,
          title: "Dance",
          time: "4:00 PM - 5:00 PM",
          dates: ["2018-04-16"],
          type: "After 4",
          day: "thursday"
        }
      ],
      date: null,
      headers: [],
      regs: []
    };
  },
  methods: {
    pickerDate(val) {
      console.log(val);
      this.courses = this.allCourses.filter(value => value.dates.includes(val));
      this.$refs.courseSelection.stage = 1;
    }
  }
};
</script>